import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef
} from '@angular/core';
import { Attachment, ATTACHMENT_STATUS } from '../../models/attachment';
import { ApiService } from '../../api/api.service';
import { LoaderService } from '../../api/loader.service';

@Component({
    selector: 'app-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.css'],
    standalone: false
})
export class ImportComponent implements OnInit {
    @Input() isVisible: EventEmitter<boolean>;
    @Input() headerTitle: string;
    @Input() fileTypes: any;
    @Input() fileSubTypes: any;
    @Input() acceptedTypes: string[];
    @Input() requiredType: boolean;
    @ViewChild('attachmentFile') attachmentFile: ElementRef;
    @Output() onSave: EventEmitter<Array<Attachment>> = new EventEmitter<Array<Attachment>>();
    @Input() filesToImport: Array<Attachment> = [];
    @Input() disabled: boolean = false;
    @Input() serviceSapError: boolean = false; //disable the button to upload files on serviceSapError
    @Input() setFilesToImport: EventEmitter<Attachment[]>;
    @Input() maxFilesToImport: number = null;

    visible: boolean = false;
    uploadDisabled: boolean = false;

    fileTypesList: Array<{ 'value': number, 'text': string }> = [];
    currentFileType: number = null;

    showPreviewDialog: boolean = false;
    setAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();

    uploading: boolean = false;

    pendingStatus: number = ATTACHMENT_STATUS.PENDING;
    activeStatus: number = ATTACHMENT_STATUS.ACTIVE;
    inactiveStatus: number = ATTACHMENT_STATUS.INACTIVE;

    constructor(
        private loaderService: LoaderService,
        private api: ApiService,
    ) { }

    ngOnInit() {
        if(this.isVisible) {
            this.isVisible.subscribe(
                visible => {
                    this.visible = visible;
            });
        }

        if(this.setFilesToImport) {
            this.setFilesToImport.subscribe(
                files => {
                    
                    
                    this.filesToImport = [...files];
                }
            )
        }

        this.generateFileTypesList();
    }

    generateFileTypesList() {
        this.fileTypesList = Object.keys(this.fileTypes).map(
            key => ({
                'value': parseInt(key),
                'text': this.fileTypes[key]
            })
        );
    }

    onStartImport() {
        this.generateFileTypesList();
        this.visible = true;
    }

    onSaveImport() {
        this.visible = false;
        this.uploading = true;

        if (this.filesToImport && this.filesToImport.length > 0){
            
            this.loaderService.display(this.uploading);
            Promise.all(
                this.filesToImport.filter(a => a.status !== this.activeStatus ).map(
                    fileMetadata => {
                        fileMetadata.status = this.pendingStatus;

                        
                        const file: File = fileMetadata.file
                        const fileName: string = file.name


                        let formData: FormData = new FormData();
                        formData.set(fileName, file, fileName)

                        return this.api.attachment.create(
                            fileMetadata.attachment_type,
                            formData
                        ).promise()
                        .then(resp => {
                            fileMetadata.id = resp;
                            fileMetadata.status = this.activeStatus;
                            
                            
                        })
                        .catch(err => {
                            fileMetadata.status = this.inactiveStatus;
                            
                        });
                    }
                )
            ).then(responses => {
                this.uploading = false;
                this.loaderService.display(this.uploading);
                
                

                this.filesToImport = [...this.filesToImport];

                
                
                this.onSave.emit(this.filesToImport);
            });
        }
    }

    onCancelImport() {
        this.visible = false;
        this.cleanUp();
    }

    onHideImport() {
        this.visible = false;
    }

    cleanUp() {
        this.currentFileType = null;
        this.attachmentFile.nativeElement.value = '';
        this.filesToImport = [];
    }

    cleanInputFile() {
        this.currentFileType = null;
        this.attachmentFile.nativeElement.value = '';
    }

    onSelectImportType(event) {
        const possibleFileType:any = event.target.value;

        if(possibleFileType === 'null') {
            this.currentFileType = null;
        } else {
            this.currentFileType = possibleFileType;
        }
    }

    onSelectImportFile(event) {
        
        
        this.uploadDisabled = false;
        const importFileList: FileList = event.target.files;

        if(this.currentFileType !== null) {
            // Append new files to import
            this.filesToImport = [
                ...this.filesToImport,
                ...Array.from(importFileList).map(
                    file => ({
                        file,
                        'attachment_type': this.currentFileType,
                        'status': this.pendingStatus
                    })
                )
            ];

            setTimeout(() => {
                this.cleanInputFile();
            }, 250);
        }
    }

    disableImportFile() {
        if (!this.maxFilesToImport) {
            return false;
        }

        if (this.filesToImport.length < this.maxFilesToImport) {
            return false;
        } else {
            return true;
        }
    }

    onRemoveImportFile(event) {
        this.filesToImport.splice(event, 1);
    }

    onRemoveImportFileRequest(event) {
        
        
        const file = this.filesToImport[event];
        
        

        if(file.id){
            this.api.attachment.delete(file.id).promise()
                .then(r => {
                    
                    
                    this.onRemoveImportFile(event);
                })
        } else {
            this.onRemoveImportFile(event);
        }
    }

    showPreviewAttachment(attachment) {
        if (!attachment.file) {
            this.setAttachment.emit(attachment);
            this.showPreviewDialog = true
        }
    }

    closePreviewAttachment() {
        this.showPreviewDialog = false;
    }

    getStatusColor(currentStatus){
        /**/
        const colors = {
            [this.pendingStatus]: 'grey',
            [this.inactiveStatus]: 'red',
            [this.activeStatus]: 'black'
        };
        /**/

        return colors[currentStatus];
    }
}
